/** Finite optional jobs, one compiler invocation at a time. A second world
 * frame and an idle task separate the first submission from optional work. */
export class DeferredWarmup {
  constructor({ jobs, schedule, canRun = () => true }) {
    if (jobs.length > 32) throw new RangeError('At most 32 shader warmup jobs');
    Object.assign(this, { jobs, schedule, canRun });
    this.worldFrames = 0;
    this.index = 0;
    this.pending = false;
    this.running = false;
    this.completed = 0;
    this.failed = 0;
  }
  afterFrame({ worldReady }) {
    if (!worldReady) return;
    this.worldFrames++;
    if (this.worldFrames < 2 || this.pending || this.running || this.index >= this.jobs.length || !this.canRun()) return;
    this.pending = true;
    this.schedule(async deadline => {
      this.pending = false;
      // Recheck at execution, since a queued idle callback can outlive a
      // visibility/phase change. An inadequate idle budget retries next frame.
      if (!this.canRun() || (deadline && deadline.timeRemaining() < 8)) return;
      this.running = true;
      try {
        await this.jobs[this.index++]();
        this.completed++;
      } catch {
        this.failed++;
      } finally {
        this.running = false;
      }
      // The next frame schedules the next job; no eager continuation chain.
    });
  }
  stats() {
    return { total: this.jobs.length, completed: this.completed, failed: this.failed, remaining: this.jobs.length - this.index, running: this.running, scheduled: this.pending };
  }
}
